import { render, staticRenderFns } from "./addOrderDialog.vue?vue&type=template&id=87492dfe&"
import script from "./addOrderDialog.vue?vue&type=script&lang=js&"
export * from "./addOrderDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports